module.exports = __webpack_public_path__ + "static/media/latam-gold.644bc68f.png";